import { metrics } from '@atlassian/browser-metrics';

import {
	type PageSegmentLoadPerformanceEventConfig,
	BMEventsType,
} from '@atlassian/browser-metrics/types';

export type LoadingMetricContentType = 'editPage' | 'viewPage';

export const embeddedViewToEditTransitionMetric = (spaEnabled?: boolean) =>
	metrics.interaction({
		key: 'embedded-confluence-view-to-edit-transition',
		custom: { 'spaEnabled': !!spaEnabled },
	});

const timings = [
	{ key: 'lazy-load', startMark: 'lazy-load-start', endMark: 'lazy-load-end' },
	{ key: 'common-load', startMark: 'common-load-start', endMark: 'common-load-end' },
	{
		key: 'iframe-content-initialized',
		startMark: 'iframe-content-initialized-start',
		endMark: 'iframe-content-initialized-end',
	},
];

const loadingMetricsConfig: Record<
	LoadingMetricContentType,
	PageSegmentLoadPerformanceEventConfig
> = {
	viewPage: {
		key: 'embedded-confluence-view-page-iframe',
		type: BMEventsType.PAGE_SEGMENT_LOAD,
		timings,
	},
	editPage: {
		key: 'embedded-confluence-edit-page-iframe',
		type: BMEventsType.PAGE_SEGMENT_LOAD,
		timings,
	},
};

const getLoadingMetricsConfig = (
    contentType: LoadingMetricContentType,
    spaEnabled?: boolean,
): PageSegmentLoadPerformanceEventConfig => {
    return { ...loadingMetricsConfig[contentType], custom: { 'spaEnabled': !!spaEnabled } };
};

export const embeddedConfluenceIframeLoadMetrics = (contentType: LoadingMetricContentType, spaEnabled?: boolean) =>
	metrics.pageSegmentLoad(getLoadingMetricsConfig(contentType, spaEnabled));
